import { notification } from "antd";
import { createContext, useContext } from "react";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <NotificationContext.Provider value={api}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const api = useContext(NotificationContext);
  if (!api) {
    throw new Error("useNotify must be used within a NotificationProvider");
  }
  return api;
};
